import $ from 'jquery';
import Cookies from 'js-cookie';
import * as CONST from '../../common/utils/constants';
import Util from '../../common/utils/ui';

class Banner {
    constructor() {}

    init() {
        this.checkBottomBanner();
        this.syncNotificationBannerState();
        this.bindEvents();
        // this.setMarginTop();
    }

    // Header is position: fixed, so we need to add a margin-top to the body that is the size of the header
    setMarginTop() {
        const header = $('.header');
        const headerHeight = header[0].offsetHeight;
        $('body').css('padding-top', headerHeight);
    }

    checkBottomBanner() {
        // if it exists, and the cookie hasnt been accepted, add padding bottom
        if ($('.banner--cookie')) {
            if ($('.banner--cookie').css('display') === 'none') {
                $('.footer').css('paddingBottom', 0);
            } /*else {
                $('.footer').css('paddingBottom', 75);
            }*/
        } else {
            $('.footer').css('paddingBottom', 0);
        }
    }

    bindEvents() { 
        $(document).on('click keypress', '.js-banner-close', e => {
            const createCookie = $(e.currentTarget).data('create-cookie');
            const bannerId = $(e.currentTarget).data('banner-id');
            const expirationDays = $(e.currentTarget).data('expiration-days');

			this.closeBanner($(e.currentTarget));

            // Check if we should create a cookie or not
            if (createCookie) {
                // Check if cookie exists
                if (Cookies.get('lp.banners') && Cookies.get('lp.banners').length) {
                    // Update cookie list
                    const bannerIdList = [Cookies.get('lp.banners'), bannerId].join(',');
                    Cookies.set('lp.banners', bannerIdList, { expires: expirationDays });
                }
                else {
                    // Create cookie
                    Cookies.set('lp.banners', bannerId, { expires: expirationDays });
                }
                // remove bottom padding to account for cookie banner
                $('.footer').css('paddingBottom', 0);
            } else {
                // add bottom padding to account for cookie banner
                $('.footer').css('paddingBottom', 75);
            }
            // Recalculate height of header
            const headerNotBannerHeight = $('.js-header-wrap')[0].offsetHeight;

            $('body').animate({
                // paddingTop: headerNotBannerHeight
            }, 400);
        });
        // banner margin-top reset on resize - only apply after done resizing
        let rtime = -1;
        let timeout = false;
        const delta = 200;

        function resizeEnd() {
            if (new Date() - rtime < delta) {
                setTimeout(resizeEnd, delta);
            } else {
                timeout = false;
                // const header = $('.header');
                // const headerHeight = header[0].offsetHeight;
                // $('body').css('padding-top', headerHeight);
            }
        }

        $(window).resize(() => {
            rtime = new Date();
            if (timeout === false) {
                timeout = true;
                setTimeout(resizeEnd, delta);
            }
        });
    }

    syncNotificationBannerState() {
        const notificationBanner = $('#jsBannerNotification');

        if (!notificationBanner.length) {
            $('body').removeClass('notification-banner-open').addClass('notification-banner-closed');
            return;
        }

        const isClosed = notificationBanner.hasClass('closed') || notificationBanner.css('display') === 'none';
        $('body').toggleClass('notification-banner-open', !isClosed);
        $('body').toggleClass('notification-banner-closed', isClosed);
    }

    closeBanner(e) {
        const banner = $(e).closest('.banner');

        banner.slideToggle();
        banner.addClass('closed');

        if (banner.hasClass('banner--notification')) {
            this.syncNotificationBannerState();
        }
    }
}

export default Banner;

$(() => {
	const banner = new Banner();
	banner.init();
});
